import React from 'react';
import {
  BadgeCheck,
  ClipboardList,
  Wallet,
  CalendarCheck,
  GraduationCap,
  ReceiptIndianRupee,
  FileText,
  MessageCircle,
  LineChart,
  IdCard,
} from 'lucide-react';
import LandingSection from './LandingSection';
import LandingCard from './LandingCard';

const ITEMS = [
  { icon: BadgeCheck, title: 'Admissions', desc: 'Structured student onboarding and profiles.' },
  { icon: ClipboardList, title: 'Attendance', desc: 'Daily marking with reports and exports.' },
  { icon: Wallet, title: 'Payroll', desc: 'Optional salary workflows for staff.' },
  { icon: CalendarCheck, title: 'Academic year', desc: 'Year-wise data with quick switching.' },
  { icon: GraduationCap, title: 'Exams', desc: 'Results, analytics, and marks entry (optional).' },
  { icon: ReceiptIndianRupee, title: 'Fee collection', desc: 'Receipts, dues, and payment history.' },
  { icon: FileText, title: 'Certificates', desc: 'Generate templates and exports.' },
  { icon: IdCard, title: 'ID cards', desc: 'Print-ready cards and student portal access.' },
  { icon: MessageCircle, title: 'Communication', desc: 'Announcements and reminders.' },
  { icon: LineChart, title: 'Analytics', desc: 'Dashboards for clarity and decisions.' },
];

export default function LandingManagementFeatures() {
  return (
    <LandingSection
      id="management"
      title="School management features"
      subtitle="A focused toolkit to run daily operations—without complexity."
      innerClassName="grid gap-3 sm:grid-cols-2 lg:grid-cols-5"
      withTopDivider
    >
      {ITEMS.map((it) => {
        const Icon = it.icon;
        return (
          <LandingCard key={it.title} className="p-4 lg:p-5">
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-blue-600/20">
              <Icon className="h-4 w-4 text-blue-300" />
            </div>
            <p className="mt-3 text-sm font-semibold text-white">{it.title}</p>
            <p className="mt-1 text-xs leading-relaxed text-white/50">{it.desc}</p>
          </LandingCard>
        );
      })}
    </LandingSection>
  );
}

